// This file is auto-generated by @hey-api/openapi-ts

import { type Client, formDataBodySerializer, type Options as Options2, type TDataShape } from './client';
import { client } from './client.gen';
import type { DeleteCategoryData, DeleteCategoryResponses, DeleteNetworkData, DeleteNetworkResponses, DeleteProjectApprovalData, DeleteProjectApprovalResponses, DeleteProjectAttachmentData, DeleteProjectAttachmentResponses, DeleteProjectCategoryData, DeleteProjectCategoryResponses, DeleteProjectData, DeleteProjectIssueData, DeleteProjectIssueResponses, DeleteProjectNoteData, DeleteProjectNoteResponses, DeleteProjectResponses, DeleteProjectSectionData, DeleteProjectSectionQuestionData, DeleteProjectSectionQuestionResponses, DeleteProjectSectionResponses, DeleteProjectWatchData, DeleteProjectWatchResponses, DeleteProjectWeightsetData, DeleteProjectWeightsetResponses, DeleteRelationshipData, DeleteRelationshipResponses, DeleteReltypeData, DeleteReltypeResponses, DeleteTagAssignData, DeleteTagAssignResponses, DeleteTagData, DeleteTagResponses, DeleteUserData, DeleteUserResponses, DeleteWebhookData, DeleteWebhookResponses, GetAnswerAttachmentData, GetAnswerAttachmentResponses, GetCategoriesData, GetCategoriesResponses, GetCategoryData, GetCategoryResponses, GetElementAnswersData, GetElementAnswersResponses, GetEventData, GetEventResponses, GetEventsData, GetEventsResponses, GetEventTypesData, GetEventTypesResponses, GetIssueData, GetIssueResponses, GetIssuesData, GetIssuesResponses, GetNetworkData, GetNetworkResponses, GetOrganisationData, GetOrganisationResponses, GetOrganisationsData, GetOrganisationsResponses, GetPermissionsData, GetPermissionsResponses, GetProjectAnswerattachmentsData, GetProjectAnswerattachmentsResponses, GetProjectAnswersData, GetProjectAnswersResponses, GetProjectApprovalsData, GetProjectApprovalsResponses, GetProjectAttachmentData, GetProjectAttachmentResponses, GetProjectAttachmentsData, GetProjectAttachmentsResponses, GetProjectCalcautoscoresData, GetProjectCalcautoscoresResponses, GetProjectData, GetProjectEventsData, GetProjectEventsResponses, GetProjectIssueAttachmentData, GetProjectIssueAttachmentResponses, GetProjectIssueattachmentsData, GetProjectIssueattachmentsResponses, GetProjectIssueData, GetProjectIssueQuestionData, GetProjectIssueQuestionResponses, GetProjectIssueResponses, GetProjectIssuesData, GetProjectIssuesResponses, GetProjectNodesData, GetProjectNodesResponses, GetProjectNotesData, GetProjectNotesResponses, GetProjectParticipantsData, GetProjectParticipantsResponses, GetProjectPermissionsData, GetProjectPermissionsResponses, GetProjectQstatsData, GetProjectQstatsResponses, GetProjectReportMswordData, GetProjectReportMswordResponses, GetProjectReportQtextData, GetProjectReportQtextResponses, GetProjectReportYesnoData, GetProjectReportYesnoResponses, GetProjectResponses, GetProjectScoresData, GetProjectScoresetsData, GetProjectScoresetsResponses, GetProjectScoresResponses, GetProjectsData, GetProjectSectionData, GetProjectSectionIssueAnswersData, GetProjectSectionIssueAnswersResponses, GetProjectSectionIssueScoresData, GetProjectSectionIssueScoresResponses, GetProjectSectionQuestionData, GetProjectSectionQuestionResponses, GetProjectSectionResponses, GetProjectSectionWeightingsData, GetProjectSectionWeightingsResponses, GetProjectsResponses, GetProjectTreenodesData, GetProjectTreenodesResponses, GetProjectUserPermissionsData, GetProjectUserPermissionsResponses, GetProjectUsersData, GetProjectUsersResponses, GetProjectWatchlistData, GetProjectWatchlistResponses, GetProjectWeightingsData, GetProjectWeightingsResponses, GetProjectWeightsetsData, GetProjectWeightsetsResponses, GetQuestionAnswersData, GetQuestionAnswersResponses, GetQuestionElementAttachmentData, GetQuestionElementAttachmentResponses, GetQuestionEventsData, GetQuestionEventsResponses, GetQuestionInstancesData, GetQuestionInstancesResponses, GetQuestionIssueAnswersData, GetQuestionIssueAnswersResponses, GetQuestionIssueCommentsData, GetQuestionIssueCommentsResponses, GetQuestionScoresData, GetQuestionScoresResponses, GetReltypesData, GetReltypesResponses, GetRoleData, GetRoleResponses, GetRolesData, GetRolesResponses, GetSearchData, GetSearchResponses, GetSectionScoresData, GetSectionScoresResponses, GetSectionScoresummariesData, GetSectionScoresummariesResponses, GetTagsData, GetTagsResponses, GetTagsSectionData, GetTagsSectionResponses, GetUserData, GetUserResponses, GetUsersData, GetUsersResponses, GetVendorData, GetVendorResponses, GetWebhookEventsData, GetWebhookEventsResponses, GetWebhooksData, GetWebhooksResponses, PostCategoryData, PostCategoryResponses, PostClientData, PostClientResponses, PostIssueStatusData, PostIssueStatusResponses, PostNetworkProjectData, PostNetworkProjectResponses, PostProjectApprovalData, PostProjectApprovalResponses, PostProjectAttachmentData, PostProjectAttachmentResponses, PostProjectCalcautoscoresData, PostProjectCalcautoscoresResponses, PostProjectData, PostProjectIssueData, PostProjectIssueResponses, PostProjectNoteData, PostProjectNoteResponses, PostProjectQuestionsReplaceData, PostProjectQuestionsReplaceResponses, PostProjectResponses, PostProjectSectionData, PostProjectSectionExcelData, PostProjectSectionExcelResponses, PostProjectSectionImportData, PostProjectSectionImportResponses, PostProjectSectionQuestionCopyData, PostProjectSectionQuestionCopyResponses, PostProjectSectionQuestionData, PostProjectSectionQuestionResponses, PostProjectSectionQuestionUnlinkData, PostProjectSectionQuestionUnlinkResponses, PostProjectSectionResponses, PostProjectWatchData, PostProjectWatchResponses, PostProjectWeightingsData, PostProjectWeightingsResponses, PostProjectWeightsetData, PostProjectWeightsetResponses, PostQuestionScoreCommentData, PostQuestionScoreCommentResponses, PostQuestionScoreData, PostQuestionScoreResponses, PostRelationshipData, PostRelationshipResponses, PostReltypeData, PostReltypeResponses, PostSectionScoresetScoresData, PostSectionScoresetScoresResponses, PostTagAssignData, PostTagAssignResponses, PostTagData, PostTagResponses, PostUserData, PostUserResponses, PostWebhookData, PostWebhookResponses, PutCategoryData, PutCategoryResponses, PutOrganisationData, PutOrganisationResponses, PutProjectCategoryData, PutProjectCategoryResponses, PutProjectCloseData, PutProjectCloseResponses, PutProjectData, PutProjectIssueData, PutProjectIssueResponses, PutProjectMovesectionData, PutProjectMovesectionResponses, PutProjectNoteData, PutProjectNoteResponses, PutProjectParticipantsData, PutProjectParticipantsResponses, PutProjectPermissionsData, PutProjectPermissionsResponses, PutProjectPublishData, PutProjectPublishResponses, PutProjectQuestionElementData, PutProjectQuestionElementResponses, PutProjectResponses, PutProjectSectionChildrenData, PutProjectSectionChildrenResponses, PutProjectSectionData, PutProjectSectionQuestionData, PutProjectSectionQuestionResponses, PutProjectSectionResponses, PutProjectWeightsetData, PutProjectWeightsetResponses, PutReltypeData, PutReltypeResponses, PutTagData, PutTagResponses, PutUserData, PutUserResponses, PutWebhookData, PutWebhookResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * Download the Answer Attachment with the given ID
 */
export const getAnswerAttachment = <ThrowOnError extends boolean = false>(options: Options<GetAnswerAttachmentData, ThrowOnError>) => {
    return (options.client ?? client).get<GetAnswerAttachmentResponses, unknown, ThrowOnError>({
        url: '/answer/{answer_id}/attachment',
        ...options
    });
};

/**
 * Fetch an array of all Category objects for the user's organisation
 */
export const getCategories = <ThrowOnError extends boolean = false>(options?: Options<GetCategoriesData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetCategoriesResponses, unknown, ThrowOnError>({
        url: '/categories',
        ...options
    });
};

/**
 * Create a new Category belonging to the current user's organisation.
 *
 * Categories with duplicate names are not permitted and receive an HTTP 409 Response
 */
export const postCategory = <ThrowOnError extends boolean = false>(options?: Options<PostCategoryData, ThrowOnError>) => {
    return (options?.client ?? client).post<PostCategoryResponses, unknown, ThrowOnError>({
        url: '/category',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Delete the category with the given ID.
 *
 * Note that projects belong to this category are __not__ deleted
 * This action requires the user permission 'MANAGE_ORGANISATION'
 */
export const deleteCategory = <ThrowOnError extends boolean = false>(options: Options<DeleteCategoryData, ThrowOnError>) => {
    return (options.client ?? client).delete<DeleteCategoryResponses, unknown, ThrowOnError>({
        url: '/category/{category_id}',
        ...options
    });
};

/**
 * Fetch the Category object for the given ID
 */
export const getCategory = <ThrowOnError extends boolean = false>(options: Options<GetCategoryData, ThrowOnError>) => {
    return (options.client ?? client).get<GetCategoryResponses, unknown, ThrowOnError>({
        url: '/category/{category_id}',
        ...options
    });
};

/**
 * Update the name or description for the Category at the given ID
 *
 * This action requires the user permission 'MANAGE_ORGANISATION'
 */
export const putCategory = <ThrowOnError extends boolean = false>(options: Options<PutCategoryData, ThrowOnError>) => {
    return (options.client ?? client).put<PutCategoryResponses, unknown, ThrowOnError>({
        url: '/category/{category_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Create a new organisation. This operation is only valid for Consultant users creating
 * Buyer organisations for their clients.
 */
export const postClient = <ThrowOnError extends boolean = false>(options?: Options<PostClientData, ThrowOnError>) => {
    return (options?.client ?? client).post<PostClientResponses, unknown, ThrowOnError>({
        url: '/client',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * An array of answers from all projects and all issues for the provided element_id.
 *
 * Project ID, Title and Date Published are provided to be used as a reference when reviewing
 * previous answers.
 */
export const getElementAnswers = <ThrowOnError extends boolean = false>(options: Options<GetElementAnswersData, ThrowOnError>) => {
    return (options.client ?? client).get<GetElementAnswersResponses, unknown, ThrowOnError>({
        url: '/element/{element_id}/answers',
        ...options
    });
};

/**
 * List of available audit event type identifiers (public constants). Useful for filtering.
 */
export const getEventTypes = <ThrowOnError extends boolean = false>(options?: Options<GetEventTypesData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetEventTypesResponses, unknown, ThrowOnError>({
        url: '/event/types',
        ...options
    });
};

/**
 * Full details for a single audit event plus resolved context (issue info, question number,
 * section, user, project title when applicable). Returns 404 if not visible to the caller’s
 * organisation. Permission: MANAGE_ORGANISATION.
 */
export const getEvent = <ThrowOnError extends boolean = false>(options: Options<GetEventData, ThrowOnError>) => {
    return (options.client ?? client).get<GetEventResponses, unknown, ThrowOnError>({
        url: '/event/{event_id}',
        ...options
    });
};

/**
 * Organisation‑wide audit feed across all accessible projects. Optional event_type filter,
 * paged. Permission: MANAGE_ORGANISATION.
 */
export const getEvents = <ThrowOnError extends boolean = false>(options?: Options<GetEventsData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetEventsResponses, unknown, ThrowOnError>({
        url: '/events',
        ...options
    });
};

/**
 * Retrieve an Issue by ID (requires access to its Project). Permission: PROJECT_ACCESS.
 */
export const getIssue = <ThrowOnError extends boolean = false>(options: Options<GetIssueData, ThrowOnError>) => {
    return (options.client ?? client).get<GetIssueResponses, unknown, ThrowOnError>({
        url: '/issue/{issue_id}',
        ...options
    });
};

/**
 * Change Issue status (uses server‑side transition rules & permission checks; may
 * set timestamps and validate mandatory answers / deadlines). Emits appropriate
 * audit event via change_issue_status.
 */
export const postIssueStatus = <ThrowOnError extends boolean = false>(options: Options<PostIssueStatusData, ThrowOnError>) => {
    return (options.client ?? client).post<PostIssueStatusResponses, unknown, ThrowOnError>({
        url: '/issue/{issue_id}/status',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Paginated list of Issues visible to the user across all participating Projects.
 * Supports filtering by respondent (q_org_id) and status; sortable by deadline,
 * submitted_date, or issue_date (asc/desc).
 *
 * "orgId" query parameter is the ID of the respondent organisation to filter by
 * "projectIds" is an array of GET parameters to filter by project ID.
 */
export const getIssues = <ThrowOnError extends boolean = false>(options?: Options<GetIssuesData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetIssuesResponses, unknown, ThrowOnError>({
        url: '/issues',
        ...options
    });
};

/**
 * Delete all relationships defined for this network.
 * Relationship Types are not deleted.
 */
export const deleteNetwork = <ThrowOnError extends boolean = false>(options?: Options<DeleteNetworkData, ThrowOnError>) => {
    return (options?.client ?? client).delete<DeleteNetworkResponses, unknown, ThrowOnError>({
        url: '/network',
        ...options
    });
};

/**
 * Get an array of all the Network Relationships described by your organisation
 */
export const getNetwork = <ThrowOnError extends boolean = false>(options?: Options<GetNetworkData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetNetworkResponses, unknown, ThrowOnError>({
        url: '/network',
        ...options
    });
};

/**
 * Generate a network of relationships between vendors and participants for the project ID
 * provided. Creates default Relationship Types for standard RFP project relationships.
 */
export const postNetworkProject = <ThrowOnError extends boolean = false>(options: Options<PostNetworkProjectData, ThrowOnError>) => {
    return (options.client ?? client).post<PostNetworkProjectResponses, unknown, ThrowOnError>({
        url: '/network/project/{project_id}',
        ...options
    });
};

/**
 * Fetch organisation details together with an array of users.
 *
 * Consultant users can provide an "orgId" query parameter to fetch details for a client
 * organisation.
 */
export const getOrganisation = <ThrowOnError extends boolean = false>(options?: Options<GetOrganisationData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetOrganisationResponses, unknown, ThrowOnError>({
        url: '/organisation',
        ...options
    });
};

/**
 * Update name, password_expiry and public fields for the given organisation.
 */
export const putOrganisation = <ThrowOnError extends boolean = false>(options?: Options<PutOrganisationData, ThrowOnError>) => {
    return (options?.client ?? client).put<PutOrganisationResponses, unknown, ThrowOnError>({
        url: '/organisation',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Get an array of organisations. The type of organisation returned depends on the value of the
 * query parameter 'orgType':
 * - 'vendors', the default, provides an array of vendor(supplier) organisations that have been
 * invited to respond to Projects issued by the current users' organisation.
 * - 'clients' - get buyer organisations that are clients of current user's organisation. This
 * option is only valid for Consultant organisations.
 */
export const getOrganisations = <ThrowOnError extends boolean = false>(options?: Options<GetOrganisationsData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetOrganisationsResponses, unknown, ThrowOnError>({
        url: '/organisations',
        ...options
    });
};

/**
 * List all available permissions, optionally filtered by the entity type provided.
 * Valid entity types are 'project', 'issue' and 'admin'. If no entity type is provided
 * then all permissions are returned.
 */
export const getPermissions = <ThrowOnError extends boolean = false>(options?: Options<GetPermissionsData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetPermissionsResponses, unknown, ThrowOnError>({
        url: '/permissions',
        ...options
    });
};

/**
 * Create a new Project
 *
 * ID values provided in the category_ids field of the JSON request body
 * are used to link the new project to categories with those ID values.
 *
 * The 'section_id' field in the Response is the ID of the Root Section for the
 * newly created project.
 */
export const postProject = <ThrowOnError extends boolean = false>(options?: Options<PostProjectData, ThrowOnError>) => {
    return (options?.client ?? client).post<PostProjectResponses, unknown, ThrowOnError>({
        url: '/project',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Delete the given project together with all sections, subsections and questions
 */
export const deleteProject = <ThrowOnError extends boolean = false>(options: Options<DeleteProjectData, ThrowOnError>) => {
    return (options.client ?? client).delete<DeleteProjectResponses, unknown, ThrowOnError>({
        url: '/project/{project_id}',
        ...options
    });
};

/**
 * Get a project checking that the user is in a participant
 * organisation and has explicit user permissions for that project
 */
export const getProject = <ThrowOnError extends boolean = false>(options: Options<GetProjectData, ThrowOnError>) => {
    return (options.client ?? client).get<GetProjectResponses, unknown, ThrowOnError>({
        url: '/project/{project_id}',
        ...options
    });
};

/**
 * Update the project with the values contained in the UpdateableProject document.
 *
 * If 'project_fields' is provided the existing values are overwritten.
 */
export const putProject = <ThrowOnError extends boolean = false>(options: Options<PutProjectData, ThrowOnError>) => {
    return (options.client ?? client).put<PutProjectResponses, unknown, ThrowOnError>({
        url: '/project/{project_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * list Answer Attachments for the current project - attachments uploaded as answers to
 * questions with File Upload question elements
 */
export const getProjectAnswerattachments = <ThrowOnError extends boolean = false>(options: Options<GetProjectAnswerattachmentsData, ThrowOnError>) => {
    return (options.client ?? client).get<GetProjectAnswerattachmentsResponses, unknown, ThrowOnError>({
        url: '/project/{project_id}/answerattachments',
        ...options
    });
};

/**
 * Fetch Answers to all questions in the current project for the Issue IDs provided.
 *
 * __N.B.__ This operation is inefficient for projects with very many questions or Issues. A
 * maximum of 2,000 element answers will be returned. An HTTP 400 error will be returned if more
 * than 2,000 answers are found. This total does not include unanswered Question Element / Issue
 * combinations. Operation ID get_project_qstats can be used to check how many
 * answerable elements are in the project.
 *
 * Results are provided as a nested mapping object allowing easy reference when
 * assigning answers to questions for specific Issues:
 * ```
 * {
 * // ID of the Issue
 * "923": {
 *
 * // Element ID to  Answer Value
 * "2342742": "Yes, we can deliver to Jupiter",
 * "7234232": "No, we cannot deliver to Baltimore"
 *
 * }
 * }
 * ```
 * So to reference an answer for Issue 923 to Element 7234232, the notation is
 * data['923']['7234232']
 *
 * (bear in mind that numerical IDs are delivered as Strings when used as Object keys in JSON)
 */
export const getProjectAnswers = <ThrowOnError extends boolean = false>(options: Options<GetProjectAnswersData, ThrowOnError>) => {
    return (options.client ?? client).get<GetProjectAnswersResponses, unknown, ThrowOnError>({
        url: '/project/{project_id}/answers',
        ...options
    });
};

/**
 * Log an approval for the given project by the current user.
 *
 * A user may only approve a given project once for each distinct project status.
 * If the user has already approved the project for its current status then
 * an error is raised.
 *
 * The approval is recorded in the ProjectApproval table together with
 * the project status at the time of approval.
 */
export const postProjectApproval = <ThrowOnError extends boolean = false>(options: Options<PostProjectApprovalData, ThrowOnError>) => {
    return (options.client ?? client).post<PostProjectApprovalResponses, unknown, ThrowOnError>({
        url: '/project/{project_id}/approval',
        ...options
    });
};

/**
 * Remove the given approval from the project.
 *
 * Approvals can be deleted by:
 * - the user who created the approval
 * - a user with both editProject and approveProject permissions
 */
export const deleteProjectApproval = <ThrowOnError extends boolean = false>(options: Options<DeleteProjectApprovalData, ThrowOnError>) => {
    return (options.client ?? client).delete<DeleteProjectApprovalResponses, unknown, ThrowOnError>({
        url: '/project/{project_id}/approval/{approval_id}',
        ...options
    });
};

/**
 * List all approvals for the given project.
 *
 * An approval is recorded when a user approves a project for its current status.
 * A user may only approve a given project once for each distinct project status.
 */
export const getProjectApprovals = <ThrowOnError extends boolean = false>(options: Options<GetProjectApprovalsData, ThrowOnError>) => {
    return (options.client ?? client).get<GetProjectApprovalsResponses, unknown, ThrowOnError>({
        url: '/project/{project_id}/approvals',
        ...options
    });
};

/**
 * Upload a file as an attachment to the project.
 *
 * This action can be performed for Projects at status Draft or Live
 */
export const postProjectAttachment = <ThrowOnError extends boolean = false>(options: Options<PostProjectAttachmentData, ThrowOnError>) => {
    return (options.client ?? client).post<PostProjectAttachmentResponses, unknown, ThrowOnError>({
        ...formDataBodySerializer,
        url: '/project/{project_id}/attachment',
        ...options,
        headers: {
            'Content-Type': null,
            ...options.headers
        }
    });
};

/**
 * Delete the Project Attachment with the given ID
 *
 * This action can be performed for Projects at status Draft or Live
 */
export const deleteProjectAttachment = <ThrowOnError extends boolean = false>(options: Options<DeleteProjectAttachmentData, ThrowOnError>) => {
    return (options.client ?? client).delete<DeleteProjectAttachmentResponses, unknown, ThrowOnError>({
        url: '/project/{project_id}/attachment/{attachment_id}',
        ...options
    });
};

/**
 * Download the Project Attachment with the given ID
 */
export const getProjectAttachment = <ThrowOnError extends boolean = false>(options: Options<GetProjectAttachmentData, ThrowOnError>) => {
    return (options.client ?? client).get<GetProjectAttachmentResponses, unknown, ThrowOnError>({
        url: '/project/{project_id}/attachment/{attachment_id}',
        ...options
    });
};

/**
 * list details for all Project Attachments (attachments uploaded by the Project author - buyer)
 */
export const getProjectAttachments = <ThrowOnError extends boolean = false>(options: Options<GetProjectAttachmentsData, ThrowOnError>) => {
    return (options.client ?? client).get<GetProjectAttachmentsResponses, unknown, ThrowOnError>({
        url: '/project/{project_id}/attachments',
        ...options
    });
};

/**
 * Preview autoscores (not persisted) for a target scorer’s set. Requires: Live project,
 * multiscored, participant target, proper save/agreed permissions.
 */
export const getProjectCalcautoscores = <ThrowOnError extends boolean = false>(options: Options<GetProjectCalcautoscoresData, ThrowOnError>) => {
    return (options.client ?? client).get<GetProjectCalcautoscoresResponses, unknown, ThrowOnError>({
        url: '/project/{project_id}/calcautoscores',
        ...options
    });
};

/**
 * Persist autoscores into a target scorer’s set. Skips unchanged values. Emits create/change
 * audit events (autoscore flagged). Same preconditions as preview.
 */
export const postProjectCalcautoscores = <ThrowOnError extends boolean = false>(options: Options<PostProjectCalcautoscoresData, ThrowOnError>) => {
    return (options.client ?? client).post<PostProjectCalcautoscoresResponses, unknown, ThrowOnError>({
        url: '/project/{project_id}/calcautoscores',
        ...options
    });
};

/**
 * Remove the category with the given ID from the project at this URL
 */
export const deleteProjectCategory = <ThrowOnError extends boolean = false>(options: Options<DeleteProjectCategoryData, ThrowOnError>) => {
    return (options.client ?? client).delete<DeleteProjectCategoryResponses, unknown, ThrowOnError>({
        url: '/project/{project_id}/category/{category_id}',
        ...options
    });
};

/**
 * Assign the category with the given ID to the project at this URL
 */
export const putProjectCategory = <ThrowOnError extends boolean = false>(options: Options<PutProjectCategoryData, ThrowOnError>) => {
    return (options.client ?? client).put<PutProjectCategoryResponses, unknown, ThrowOnError>({
        url: '/project/{project_id}/category/{category_id}',
        ...options
    });
};

/**
 * Close the given project.
 *
 * Changes the status of the Project from 'Live' to 'Closed'.
 * Any pending issues at status 'Opportunity' will be retracted.
 */
export const putProjectClose = <ThrowOnError extends boolean = false>(options: Options<PutProjectCloseData, ThrowOnError>) => {
    return (options.client ?? client).put<PutProjectCloseResponses, unknown, ThrowOnError>({
        url: '/project/{project_id}/close',
        ...options
    });
};

/**
 * Project‑scoped audit timeline. Returns lightweight events (id, timestamp, user_id, type)
 * visible to the caller’s organisation. Optional filtering by event_type. Supports paging.
 * Permission: PROJECT_ACCESS.
 */
export const getProjectEvents = <ThrowOnError extends boolean = false>(options: Options<GetProjectEventsData, ThrowOnError>) => {
    return (options.client ?? client).get<GetProjectEventsResponses, unknown, ThrowOnError>({
        url: '/project/{project_id}/events',
        ...options
    });
};

/**
 * Create a new Issue (invitation). Exactly one of respondent_id or respondent_email
 * must be supplied. Starts in Not Sent status. Emits ISSUE_CREATED audit event with
 * initial field values.
 */
export const postProjectIssue = <ThrowOnError extends boolean = false>(options: Options<PostProjectIssueData, ThrowOnError>) => {
    return (options.client ?? client).post<PostProjectIssueResponses, unknown, ThrowOnError>({
        url: '/project/{project_id}/issue',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Delete an Issue (permitted only while it is Not Sent, Declined, or Retracted).
 * Emits ISSUE_DELETED audit event.
 */
export const deleteProjectIssue = <ThrowOnError extends boolean = false>(options: Options<DeleteProjectIssueData, ThrowOnError>) => {
    return (options.client ?? client).delete<DeleteProjectIssueResponses, unknown, ThrowOnError>({
        url: '/project/{project_id}/issue/{issue_id}',
        ...options
    });
};

/**
 * Retrieve a single Issue within a Project. Permission: PROJECT_ACCESS.
 */
export const getProjectIssue = <ThrowOnError extends boolean = false>(options: Options<GetProjectIssueData, ThrowOnError>) => {
    return (options.client ?? client).get<GetProjectIssueResponses, unknown, ThrowOnError>({
        url: '/project/{project_id}/issue/{issue_id}',
        ...options
    });
};

/**
 * Update mutable Issue fields (e.g. label, deadlines, win/loss exposure). Status
 * changes are NOT allowed here (use status endpoint). Emits ISSUE_UPDATED audit event
 * with per‑field change log.
 */
export const putProjectIssue = <ThrowOnError extends boolean = false>(options: Options<PutProjectIssueData, ThrowOnError>) => {
    return (options.client ?? client).put<PutProjectIssueResponses, unknown, ThrowOnError>({
        url: '/project/{project_id}/issue/{issue_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Download the Issue Attachment with the given ID
 */
export const getProjectIssueAttachment = <ThrowOnError extends boolean = false>(options: Options<GetProjectIssueAttachmentData, ThrowOnError>) => {
    return (options.client ?? client).get<GetProjectIssueAttachmentResponses, unknown, ThrowOnError>({
        url: '/project/{project_id}/issue/{issue_id}/attachment/{attachment_id}',
        ...options
    });
};

/**
 * Get the answered question for the given project and issue.
 */
export const getProjectIssueQuestion = <ThrowOnError extends boolean = false>(options: Options<GetProjectIssueQuestionData, ThrowOnError>) => {
    return (options.client ?? client).get<GetProjectIssueQuestionResponses, unknown, ThrowOnError>({
        url: '/project/{project_id}/issue/{issue_id}/question',
        ...options
    });
};

/**
 * list all Issue attachments (uploaded by Respondents) for the current Project
 */
export const getProjectIssueattachments = <ThrowOnError extends boolean = false>(options: Options<GetProjectIssueattachmentsData, ThrowOnError>) => {
    return (options.client ?? client).get<GetProjectIssueattachmentsResponses, unknown, ThrowOnError>({
        url: '/project/{project_id}/issueattachments',
        ...options
    });
};

/**
 * List all Issues for a Project (no pagination). Permission: PROJECT_ACCESS.
 */
export const getProjectIssues = <ThrowOnError extends boolean = false>(options: Options<GetProjectIssuesData, ThrowOnError>) => {
    return (options.client ?? client).get<GetProjectIssuesResponses, unknown, ThrowOnError>({
        url: '/project/{project_id}/issues',
        ...options
    });
};

/**
 * Move the section given by section_id to a location with the same project given by
 * new_parent_id - the ID of the new Parent section
 */
export const putProjectMovesection = <ThrowOnError extends boolean = false>(options: Options<PutProjectMovesectionData, ThrowOnError>) => {
    return (options.client ?? client).put<PutProjectMovesectionResponses, unknown, ThrowOnError>({
        url: '/project/{project_id}/movesection',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get an array of subsections and questions for the given project id and section id.
 * If section ID is not provided then results for the root section of the project are returned.
 *
 * If ancestors parameter is true or 1, then nodes of all direct ancestors and siblings of those
 * ancestors are returned, facilitating the respresentation of a tree structure.
 *
 * Each section or question is a "node" in the questionnaire. The array
 * is sorted in document order: 1.1.1, 1.1.2, 1.2.1, 1.2.2 etc.
 */
export const getProjectNodes = <ThrowOnError extends boolean = false>(options: Options<GetProjectNodesData, ThrowOnError>) => {
    return (options.client ?? client).get<GetProjectNodesResponses, unknown, ThrowOnError>({
        url: '/project/{project_id}/nodes',
        ...options
    });
};

/**
 * Add a Note to the given Project
 *
 * The visibility of Notes to different organisation is given by the table below - the last three
 * columns indicate the visiblity of the message to each group.
 *
 * |private|target_org_id defined|all respondents? |target respondent?|participants?   |
 * |-------|---------------------|-----------------|------------------|----------------|
 * |false  | true                | no              |  yes             | yes            |
 * |false  | false               | yes             |  not applicable  | yes            |
 * |true   | false               | yes             |  not applicable  | yes            |
 * |true   | true                | no              |  no              | yes            |
 *
 *
 * Field 'target_org_id' is the ID of the Organisation to whom a Note is addressed. The
 * Organisation must be a respondent for the current Project
 * (i.e assigned as Respondent for an Issue).
 *
 * Setting 'target_org_id' has no effect if the message is private (in which case only users in
 * Particpant organisations can view the message)
 *
 * Permissions: PROJECT_ADD_NOTE
 */
export const postProjectNote = <ThrowOnError extends boolean = false>(options: Options<PostProjectNoteData, ThrowOnError>) => {
    return (options.client ?? client).post<PostProjectNoteResponses, unknown, ThrowOnError>({
        url: '/project/{project_id}/note',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Delete a Project Note
 *
 * Permissions: PROJECT_ADD_NOTE
 */
export const deleteProjectNote = <ThrowOnError extends boolean = false>(options: Options<DeleteProjectNoteData, ThrowOnError>) => {
    return (options.client ?? client).delete<DeleteProjectNoteResponses, unknown, ThrowOnError>({
        url: '/project/{project_id}/note/{note_id}',
        ...options
    });
};

/**
 * Update a Project Note. See Post Project Note for details of privacy and visibility
 *
 * Permissions: PROJECT_ADD_NOTE
 */
export const putProjectNote = <ThrowOnError extends boolean = false>(options: Options<PutProjectNoteData, ThrowOnError>) => {
    return (options.client ?? client).put<PutProjectNoteResponses, unknown, ThrowOnError>({
        url: '/project/{project_id}/note/{note_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get a list of ProjectNotes for the given project_id.
 */
export const getProjectNotes = <ThrowOnError extends boolean = false>(options: Options<GetProjectNotesData, ThrowOnError>) => {
    return (options.client ?? client).get<GetProjectNotesResponses, unknown, ThrowOnError>({
        url: '/project/{project_id}/notes',
        ...options
    });
};

/**
 * List organisations that are registered as Participants in the given project together
 * with the Role assigned in the given project.
 */
export const getProjectParticipants = <ThrowOnError extends boolean = false>(options: Options<GetProjectParticipantsData, ThrowOnError>) => {
    return (options.client ?? client).get<GetProjectParticipantsResponses, unknown, ThrowOnError>({
        url: '/project/{project_id}/participants',
        ...options
    });
};

/**
 * Update the Organisations participating in the given project together with their Roles
 *
 * The current user's own Organisation cannot be removed as participant.
 */
export const putProjectParticipants = <ThrowOnError extends boolean = false>(options: Options<PutProjectParticipantsData, ThrowOnError>) => {
    return (options.client ?? client).put<PutProjectParticipantsResponses, unknown, ThrowOnError>({
        url: '/project/{project_id}/participants',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * returns {
 * target_user: user whose permissions are in focus
 * permissions: list of section ids the user can access
 * }
 */
export const getProjectPermissions = <ThrowOnError extends boolean = false>(options: Options<GetProjectPermissionsData, ThrowOnError>) => {
    return (options.client ?? client).get<GetProjectPermissionsResponses, unknown, ThrowOnError>({
        url: '/project/{project_id}/permissions',
        ...options
    });
};

/**
 * Assign section permissions for a restricted user to access the project
 */
export const putProjectPermissions = <ThrowOnError extends boolean = false>(options: Options<PutProjectPermissionsData, ThrowOnError>) => {
    return (options.client ?? client).put<PutProjectPermissionsResponses, unknown, ThrowOnError>({
        url: '/project/{project_id}/permissions',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Publish a project.
 *
 * Changes the status of the Project from 'Draft' to 'Live'.
 *
 * ### Update Issue Statuses
 *
 * When project is published it is often useful to simultaneously "release" the issues that
 * belong to the project. "Release" means to change the status of an issue from 'Not Sent' to
 * either 'Opportunity' or 'Accepted', depending on the value of the parent project's
 * 'Required Acceptance' field.
 *
 * If the Project's require_acceptance field is true, the the status of each Issue
 * will change from 'Not Sent' to 'Opportunity'.
 *
 * If the Project's required_acceptance field is false the each Issue will move from
 * status 'Not Sent' to 'Accepted'.
 *
 * Only issues whose ID values are included in the JSON body 'release_issue_ids' field will
 * be updated.
 *
 * If there are no values given in the JSON body field 'release_issue_id'
 * then the status of all issues belong to the project remain unchanged.
 *
 * ID values in 'release_issue_ids' that do not belong to the current project are ignored.
 */
export const putProjectPublish = <ThrowOnError extends boolean = false>(options: Options<PutProjectPublishData, ThrowOnError>) => {
    return (options.client ?? client).put<PutProjectPublishResponses, unknown, ThrowOnError>({
        url: '/project/{project_id}/publish',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Retrieve statistics for counts of sections, questions and question elements (by type)
 * for the given project ID.
 */
export const getProjectQstats = <ThrowOnError extends boolean = false>(options: Options<GetProjectQstatsData, ThrowOnError>) => {
    return (options.client ?? client).get<GetProjectQstatsResponses, unknown, ThrowOnError>({
        url: '/project/{project_id}/qstats',
        ...options
    });
};

/**
 * Update a single Question Element
 */
export const putProjectQuestionElement = <ThrowOnError extends boolean = false>(options: Options<PutProjectQuestionElementData, ThrowOnError>) => {
    return (options.client ?? client).put<PutProjectQuestionElementResponses, unknown, ThrowOnError>({
        url: '/project/{project_id}/question/{question_id}/element/{element_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Replace search_term with replace_term (from the Request's json body) in all questions in the
 * project. Question titles, label field and multiple choice options are updated.
 *
 * If the JSON body field 'dry_run' is true then no update is made, but the results returned
 * show what changes would be made.
 *
 * The Response is an array of ReplacedItem records, one for each question element or question
 * title that has been changed, together with the old and new values.
 *
 * This search is case sensitive
 */
export const postProjectQuestionsReplace = <ThrowOnError extends boolean = false>(options: Options<PostProjectQuestionsReplaceData, ThrowOnError>) => {
    return (options.client ?? client).post<PostProjectQuestionsReplaceResponses, unknown, ThrowOnError>({
        url: '/project/{project_id}/questions/replace',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Generate an MS Word report for the quesionnaire associated with the given Project ID.
 * If an issue ID is provided the answers are populated for that Issue.
 */
export const getProjectReportMsword = <ThrowOnError extends boolean = false>(options: Options<GetProjectReportMswordData, ThrowOnError>) => {
    return (options.client ?? client).get<GetProjectReportMswordResponses, unknown, ThrowOnError>({
        url: '/project/{project_id}/report/msword',
        ...options
    });
};

/**
 * Generate a spreadsheet with one row for each question and one column for title and then each
 * Label (question text) element in the question.
 *
 * Useful for checking all the text in a questionnaire.
 */
export const getProjectReportQtext = <ThrowOnError extends boolean = false>(options: Options<GetProjectReportQtextData, ThrowOnError>) => {
    return (options.client ?? client).get<GetProjectReportQtextResponses, unknown, ThrowOnError>({
        url: '/project/{project_id}/report/qtext',
        ...options
    });
};

/**
 * Generate a spreadsheet report of answer to questions with a specific structure of 4 rows:
 *
 * 1. Question Body
 * 2. Multiple choice options, e.g. 'Yes; No; Yes, with Qualifications'
 * 3. Comments box header, e.g. 'Qualifications'
 * 4. Text input field
 *
 * Questions not matching this structure are ignored
 */
export const getProjectReportYesno = <ThrowOnError extends boolean = false>(options: Options<GetProjectReportYesnoData, ThrowOnError>) => {
    return (options.client ?? client).get<GetProjectReportYesnoResponses, unknown, ThrowOnError>({
        url: '/project/{project_id}/report/yesno',
        ...options
    });
};

/**
 * Bulk export of all scores for a project in one score set (agreed or individual) for
 * analytic use. "__default__" resolves to the agreed set. Permission: ISSUE_VIEW_AGREED_SCORES.
 */
export const getProjectScores = <ThrowOnError extends boolean = false>(options: Options<GetProjectScoresData, ThrowOnError>) => {
    return (options.client ?? client).get<GetProjectScoresResponses, unknown, ThrowOnError>({
        url: '/project/{project_id}/scores',
        ...options
    });
};

/**
 * list accessible score sets. With ISSUE_VIEW_AGREED_SCORES returns all distinct user sets
 * plus synthetic agreed set (__default__). Otherwise returns only caller’s own set.
 */
export const getProjectScoresets = <ThrowOnError extends boolean = false>(options: Options<GetProjectScoresetsData, ThrowOnError>) => {
    return (options.client ?? client).get<GetProjectScoresetsResponses, unknown, ThrowOnError>({
        url: '/project/{project_id}/scoresets',
        ...options
    });
};

/**
 * Delete the given Section and all questions and subsections contained within that
 * section.
 */
export const deleteProjectSection = <ThrowOnError extends boolean = false>(options: Options<DeleteProjectSectionData, ThrowOnError>) => {
    return (options.client ?? client).delete<DeleteProjectSectionResponses, unknown, ThrowOnError>({
        url: '/project/{project_id}/section/{section_id}',
        ...options
    });
};

/**
 * Get the Section with the given ID together with questions and subsections contained
 * within the Section.
 */
export const getProjectSection = <ThrowOnError extends boolean = false>(options: Options<GetProjectSectionData, ThrowOnError>) => {
    return (options.client ?? client).get<GetProjectSectionResponses, unknown, ThrowOnError>({
        url: '/project/{project_id}/section/{section_id}',
        ...options
    });
};

/**
 * Create a new Section
 */
export const postProjectSection = <ThrowOnError extends boolean = false>(options: Options<PostProjectSectionData, ThrowOnError>) => {
    return (options.client ?? client).post<PostProjectSectionResponses, unknown, ThrowOnError>({
        url: '/project/{project_id}/section/{section_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Update title or description for the given Section
 */
export const putProjectSection = <ThrowOnError extends boolean = false>(options: Options<PutProjectSectionData, ThrowOnError>) => {
    return (options.client ?? client).put<PutProjectSectionResponses, unknown, ThrowOnError>({
        url: '/project/{project_id}/section/{section_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Set the contents of the Section by providing a list of section IDs *or* question IDs.
 *
 * This method can be used to move *existing* questions or sections to a new parent section or
 * to re-order existing section contents. It cannot be used to move questions or sections from a
 * different project.
 *
 * Child objects (Section or Question) which exist within the current section but whose ID is not
 * included in the JSON body parameter are termed 'orphans'.  If 'delete_orphans' is true, then
 * such objects will be deleted, i.e. the contents of the current section will be exactly the same
 * as that provided by the question_ids or section_ids parameter.
 *
 * The default value for 'delete_orphans' is false - this value should only be overridden with
 * care.
 *
 * N.B.  The JSON body object should contain either question_ids or section_ids arrays, but
 * not both.
 */
export const putProjectSectionChildren = <ThrowOnError extends boolean = false>(options: Options<PutProjectSectionChildrenData, ThrowOnError>) => {
    return (options.client ?? client).put<PutProjectSectionChildrenResponses, unknown, ThrowOnError>({
        url: '/project/{project_id}/section/{section_id}/children',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Create questions and subsections within the given section by uploading an Excel spreadsheet
 * with a specific format of 5 columns:
 *
 * - A: Section Title. Add the newly created question to this section, creating the Section if
 * necessary
 * - B: Question Title. Short - for reference and navigation
 * - C: Question Text. The body of the question
 * - D: Multiple Choices. Multiple choice options seperated by semi colons. A numeric value
 * in angle brackets, e.g. <5> after the option text is interpreted as the Autoscore value
 * for that option
 * - E: Comments Field header. If provided in conjunction with Multiple choice options the
 * value of this column is used to create a subheader below the multiple choice field
 * and above a text field for comments or qualifications.
 *
 *
 * At most 500 rows are processed. Additional rows are disregarded. If column D is empty the
 * question will consist of a single text input field.
 */
export const postProjectSectionExcel = <ThrowOnError extends boolean = false>(options: Options<PostProjectSectionExcelData, ThrowOnError>) => {
    return (options.client ?? client).post<PostProjectSectionExcelResponses, unknown, ThrowOnError>({
        ...formDataBodySerializer,
        url: '/project/{project_id}/section/{section_id}/excel',
        ...options,
        headers: {
            'Content-Type': null,
            ...options.headers
        }
    });
};

/**
 * Import questionnaire from previous project
 */
export const postProjectSectionImport = <ThrowOnError extends boolean = false>(options: Options<PostProjectSectionImportData, ThrowOnError>) => {
    return (options.client ?? client).post<PostProjectSectionImportResponses, unknown, ThrowOnError>({
        url: '/project/{project_id}/section/{section_id}/import',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Fetch an array of Answer objects for the given Project, Issue and Section
 */
export const getProjectSectionIssueAnswers = <ThrowOnError extends boolean = false>(options: Options<GetProjectSectionIssueAnswersData, ThrowOnError>) => {
    return (options.client ?? client).get<GetProjectSectionIssueAnswersResponses, unknown, ThrowOnError>({
        url: '/project/{project_id}/section/{section_id}/issue/{issue_id}/answers',
        ...options
    });
};

/**
 * Scores for a single Issue within the scope of a Section (and underlying fetch rules),
 * filtered by score set. Permission: derived from score set.
 */
export const getProjectSectionIssueScores = <ThrowOnError extends boolean = false>(options: Options<GetProjectSectionIssueScoresData, ThrowOnError>) => {
    return (options.client ?? client).get<GetProjectSectionIssueScoresResponses, unknown, ThrowOnError>({
        url: '/project/{project_id}/section/{section_id}/issue/{issue_id}/scores',
        ...options
    });
};

/**
 * Create a new Question in the given section
 */
export const postProjectSectionQuestion = <ThrowOnError extends boolean = false>(options: Options<PostProjectSectionQuestionData, ThrowOnError>) => {
    return (options.client ?? client).post<PostProjectSectionQuestionResponses, unknown, ThrowOnError>({
        url: '/project/{project_id}/section/{section_id}/question',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Delete the Question with the given ID
 *
 * The return value is an array of remaining instances of the same question that may exist
 * in other projects
 */
export const deleteProjectSectionQuestion = <ThrowOnError extends boolean = false>(options: Options<DeleteProjectSectionQuestionData, ThrowOnError>) => {
    return (options.client ?? client).delete<DeleteProjectSectionQuestionResponses, unknown, ThrowOnError>({
        url: '/project/{project_id}/section/{section_id}/question/{question_id}',
        ...options
    });
};

/**
 * Get the question with the given ID
 */
export const getProjectSectionQuestion = <ThrowOnError extends boolean = false>(options: Options<GetProjectSectionQuestionData, ThrowOnError>) => {
    return (options.client ?? client).get<GetProjectSectionQuestionResponses, unknown, ThrowOnError>({
        url: '/project/{project_id}/section/{section_id}/question/{question_id}',
        ...options
    });
};

/**
 * Update the title and question elements for the given question
 *
 * The provided JSON document must provide elements with ID values for all elements that are to
 * be retained.
 * Elements with ID values provided are updated.
 * Elements without an ID are added as new.
 * Any existing elements not provided (with matching IDs) in the JSON document are deleted.
 *
 * If items to be deleted have already been answered (in any project) this update is rejected
 * with an HTTP Status code of 409 (Conflict).
 */
export const putProjectSectionQuestion = <ThrowOnError extends boolean = false>(options: Options<PutProjectSectionQuestionData, ThrowOnError>) => {
    return (options.client ?? client).put<PutProjectSectionQuestionResponses, unknown, ThrowOnError>({
        url: '/project/{project_id}/section/{section_id}/question/{question_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Create a copy of the question (instance & definition) given by question_id
 */
export const postProjectSectionQuestionCopy = <ThrowOnError extends boolean = false>(options: Options<PostProjectSectionQuestionCopyData, ThrowOnError>) => {
    return (options.client ?? client).post<PostProjectSectionQuestionCopyResponses, unknown, ThrowOnError>({
        url: '/project/{project_id}/section/{section_id}/question/{question_id}/copy',
        ...options
    });
};

/**
 * Unlink the question from any previous projects so it can be edited freely.
 * N.B. This breaks answer & score importing between projects
 */
export const postProjectSectionQuestionUnlink = <ThrowOnError extends boolean = false>(options: Options<PostProjectSectionQuestionUnlinkData, ThrowOnError>) => {
    return (options.client ?? client).post<PostProjectSectionQuestionUnlinkResponses, unknown, ThrowOnError>({
        url: '/project/{project_id}/section/{section_id}/question/{question_id}/unlink',
        ...options
    });
};

/**
 * Get weightings for the Sections or Questions in the given section, together with the
 * absolute weighting of parent section (allowing absolute weights to be calculated for
 * subsections or questions)
 */
export const getProjectSectionWeightings = <ThrowOnError extends boolean = false>(options: Options<GetProjectSectionWeightingsData, ThrowOnError>) => {
    return (options.client ?? client).get<GetProjectSectionWeightingsResponses, unknown, ThrowOnError>({
        url: '/project/{project_id}/section/{section_id}/weightings',
        ...options
    });
};

/**
 * N.B. - this method is deprecated. Use get_project_nodes instead.
 *
 * Get an array of all sections, subsections and questions for the given project id.
 *
 * Each section or question is a "node" in the questionnaire tree structure. The array
 * is sorted in document order: 1.1.1, 1.1.2, 1.2.1, 1.2.2 etc.
 */
export const getProjectTreenodes = <ThrowOnError extends boolean = false>(options: Options<GetProjectTreenodesData, ThrowOnError>) => {
    return (options.client ?? client).get<GetProjectTreenodesResponses, unknown, ThrowOnError>({
        url: '/project/{project_id}/treenodes',
        ...options
    });
};

/**
 * Returns a User dictionary augmented with sets of permissions (string names) given the
 * the user's effective permissions in the given project. This set is derived from the
 * intersection of the user's permissions plus the user's participant organisation
 * permission (role) in the project.
 *
 * If target_user is given then the permissions apply to that user, otherwise
 * the permissions apply to the current user (user arg)
 */
export const getProjectUserPermissions = <ThrowOnError extends boolean = false>(options: Options<GetProjectUserPermissionsData, ThrowOnError>) => {
    return (options.client ?? client).get<GetProjectUserPermissionsResponses, unknown, ThrowOnError>({
        url: '/project/{project_id}/user/permissions',
        ...options
    });
};

/**
 * List all participant users with access to the project.
 */
export const getProjectUsers = <ThrowOnError extends boolean = false>(options: Options<GetProjectUsersData, ThrowOnError>) => {
    return (options.client ?? client).get<GetProjectUsersResponses, unknown, ThrowOnError>({
        url: '/project/{project_id}/users',
        ...options
    });
};

/**
 * Remove the target user from the watchlist for this project
 */
export const deleteProjectWatch = <ThrowOnError extends boolean = false>(options: Options<DeleteProjectWatchData, ThrowOnError>) => {
    return (options.client ?? client).delete<DeleteProjectWatchResponses, unknown, ThrowOnError>({
        url: '/project/{project_id}/watch',
        ...options
    });
};

/**
 * Assign a new user as a watcher of the given project.
 * Returns a list of user ids watching the current project
 */
export const postProjectWatch = <ThrowOnError extends boolean = false>(options: Options<PostProjectWatchData, ThrowOnError>) => {
    return (options.client ?? client).post<PostProjectWatchResponses, unknown, ThrowOnError>({
        url: '/project/{project_id}/watch',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List the users watching this project
 */
export const getProjectWatchlist = <ThrowOnError extends boolean = false>(options: Options<GetProjectWatchlistData, ThrowOnError>) => {
    return (options.client ?? client).get<GetProjectWatchlistResponses, unknown, ThrowOnError>({
        url: '/project/{project_id}/watchlist',
        ...options
    });
};

/**
 * Get total and instance(local) weightings for questions and sections in the current project.
 *
 * Total weightings are the normalised, hierarchical weights reflecting the weight of the parent
 * section and all ancestor sections.
 *
 * Instance weighings are the weightings that the user assigns to a question or section.
 */
export const getProjectWeightings = <ThrowOnError extends boolean = false>(options: Options<GetProjectWeightingsData, ThrowOnError>) => {
    return (options.client ?? client).get<GetProjectWeightingsResponses, unknown, ThrowOnError>({
        url: '/project/{project_id}/weightings',
        ...options
    });
};

/**
 * Batch saving/updating of Weightings
 *
 * To save default weightings set the value of weightset_id to null.
 */
export const postProjectWeightings = <ThrowOnError extends boolean = false>(options: Options<PostProjectWeightingsData, ThrowOnError>) => {
    return (options.client ?? client).post<PostProjectWeightingsResponses, unknown, ThrowOnError>({
        url: '/project/{project_id}/weightings',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Create a new Weighting Set for the given Project
 *
 * Weightings will be created for each question and section in the project. The value of
 * these weightings will be set to the initial_value field in the json body, if given,
 * or will be copied from the weightset whose ID is given by source_weightset_id.
 */
export const postProjectWeightset = <ThrowOnError extends boolean = false>(options: Options<PostProjectWeightsetData, ThrowOnError>) => {
    return (options.client ?? client).post<PostProjectWeightsetResponses, unknown, ThrowOnError>({
        url: '/project/{project_id}/weightset',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Delete the given weighting set from the Project
 */
export const deleteProjectWeightset = <ThrowOnError extends boolean = false>(options: Options<DeleteProjectWeightsetData, ThrowOnError>) => {
    return (options.client ?? client).delete<DeleteProjectWeightsetResponses, unknown, ThrowOnError>({
        url: '/project/{project_id}/weightset/{weightset_id}',
        ...options
    });
};

/**
 * Change the name of an existing Weighting Set
 */
export const putProjectWeightset = <ThrowOnError extends boolean = false>(options: Options<PutProjectWeightsetData, ThrowOnError>) => {
    return (options.client ?? client).put<PutProjectWeightsetResponses, unknown, ThrowOnError>({
        url: '/project/{project_id}/weightset/{weightset_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get an array of Weighting Set objects for the given Project
 */
export const getProjectWeightsets = <ThrowOnError extends boolean = false>(options: Options<GetProjectWeightsetsData, ThrowOnError>) => {
    return (options.client ?? client).get<GetProjectWeightsetsResponses, unknown, ThrowOnError>({
        url: '/project/{project_id}/weightsets',
        ...options
    });
};

/**
 * An array of projects that the user's organisation is a participant
 * of and that the user, if restricted, has permission to access.
 *
 * If no values are provided for project_statuses then projects with any status are returned.
 *
 * Using the "participant_id" query param will filter the list of projects to include only
 * those for which have a Participant organisation whose ID is that of participant_id. This
 * parameter is only available to users in Consultant organisations and the participant_id must
 * be the ID of an organisation that is a Client of the Consultant.
 */
export const getProjects = <ThrowOnError extends boolean = false>(options?: Options<GetProjectsData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetProjectsResponses, unknown, ThrowOnError>({
        url: '/projects',
        ...options
    });
};

/**
 * Fetch answers for question `question_id` from project structures as nested object
 * mapping issue ID to question element ID to answer.
 *
 * Results are provided as a nested mapping object allowing easy reference when
 * assigning answers to questions for specific Issues:
 * ```
 * {
 * // ID of the Issue
 * "923": {
 *
 * // Element ID to  Answer Value
 * "2342742": "Yes, we can deliver to Jupiter",
 * "7234232": "No, we cannot deliver to Baltimore"
 *
 * }
 * }
 * ```
 * So to reference an answer for Issue 923 to Element 7234232, the notation is
 * data['923']['7234232']
 *
 * (bear in mind that numerical IDs are delivered as Strings when used as Object keys in JSON)
 */
export const getQuestionAnswers = <ThrowOnError extends boolean = false>(options: Options<GetQuestionAnswersData, ThrowOnError>) => {
    return (options.client ?? client).get<GetQuestionAnswersResponses, unknown, ThrowOnError>({
        url: '/question/{question_id}/answers',
        ...options
    });
};

/**
 * Download the Question Attachment associated with the given Element ID
 */
export const getQuestionElementAttachment = <ThrowOnError extends boolean = false>(options: Options<GetQuestionElementAttachmentData, ThrowOnError>) => {
    return (options.client ?? client).get<GetQuestionElementAttachmentResponses, unknown, ThrowOnError>({
        url: '/question/{question_id}/element/{element_id}/attachment',
        ...options
    });
};

/**
 * Chronological history of QUESTION and SECTION events for all instances sharing the same
 * underlying question definition as the supplied question instance. Ordered oldest first.
 * Permission: PROJECT_VIEW_QUESTIONNAIRE (section scope).
 */
export const getQuestionEvents = <ThrowOnError extends boolean = false>(options: Options<GetQuestionEventsData, ThrowOnError>) => {
    return (options.client ?? client).get<GetQuestionEventsResponses, unknown, ThrowOnError>({
        url: '/question/{question_id}/events',
        ...options
    });
};

/**
 * Find shared instances of the given question across all projects
 */
export const getQuestionInstances = <ThrowOnError extends boolean = false>(options: Options<GetQuestionInstancesData, ThrowOnError>) => {
    return (options.client ?? client).get<GetQuestionInstancesResponses, unknown, ThrowOnError>({
        url: '/question/{question_id}/instances',
        ...options
    });
};

/**
 * Fetch an array of Answer & Element ID for the given Question, Issue
 */
export const getQuestionIssueAnswers = <ThrowOnError extends boolean = false>(options: Options<GetQuestionIssueAnswersData, ThrowOnError>) => {
    return (options.client ?? client).get<GetQuestionIssueAnswersResponses, unknown, ThrowOnError>({
        url: '/question/{question_id}/issue/{issue_id}/answers',
        ...options
    });
};

/**
 * All comments (chronological) for a specific score (question + issue + score set).
 * Empty list if score not yet created. Requires view permissions.
 */
export const getQuestionIssueComments = <ThrowOnError extends boolean = false>(options: Options<GetQuestionIssueCommentsData, ThrowOnError>) => {
    return (options.client ?? client).get<GetQuestionIssueCommentsResponses, unknown, ThrowOnError>({
        url: '/question/{question_id}/issue/{issue_id}/comments',
        ...options
    });
};

/**
 * Create or update a single score (question + issue + score set). Validates range,
 * enforces save permission, emits audit event (create/change).
 */
export const postQuestionScore = <ThrowOnError extends boolean = false>(options: Options<PostQuestionScoreData, ThrowOnError>) => {
    return (options.client ?? client).post<PostQuestionScoreResponses, unknown, ThrowOnError>({
        url: '/question/{question_id}/score',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Add a comment to (and optionally update) a score. Creates score if needed.
 * Emits SCORE_COMMENT_ADDED plus score change audit if value updated.
 */
export const postQuestionScoreComment = <ThrowOnError extends boolean = false>(options: Options<PostQuestionScoreCommentData, ThrowOnError>) => {
    return (options.client ?? client).post<PostQuestionScoreCommentResponses, unknown, ThrowOnError>({
        url: '/question/{question_id}/score/comment',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Scores for one question across all Issues in a specified score set (agreed or individual).
 * Permission determined by score set context.
 */
export const getQuestionScores = <ThrowOnError extends boolean = false>(options: Options<GetQuestionScoresData, ThrowOnError>) => {
    return (options.client ?? client).get<GetQuestionScoresResponses, unknown, ThrowOnError>({
        url: '/question/{question_id}/scores',
        ...options
    });
};

/**
 * Delete a new Relationship between two organisations
 */
export const deleteRelationship = <ThrowOnError extends boolean = false>(options?: Options<DeleteRelationshipData, ThrowOnError>) => {
    return (options?.client ?? client).delete<DeleteRelationshipResponses, unknown, ThrowOnError>({
        url: '/relationship',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Create a new Relationship between two organisations
 */
export const postRelationship = <ThrowOnError extends boolean = false>(options?: Options<PostRelationshipData, ThrowOnError>) => {
    return (options?.client ?? client).post<PostRelationshipResponses, unknown, ThrowOnError>({
        url: '/relationship',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Create a new Relationship Type for your organisation
 *
 * A RelationshipType must be defined for your organisation before a Relationship can
 * be defined between two 3rd party organisations.
 * Multiple RelationshipTypes can be defined for your organisation in order to model different
 * types of inter-organisation relationships - e.g. 'Partner', 'Downstream Supplier',
 * 'Regulator', etc.
 */
export const postReltype = <ThrowOnError extends boolean = false>(options?: Options<PostReltypeData, ThrowOnError>) => {
    return (options?.client ?? client).post<PostReltypeResponses, unknown, ThrowOnError>({
        url: '/reltype',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Delete the Relationship Type with the given ID together with all
 * relationships of that type. Underlying Organisations are not deleted.
 */
export const deleteReltype = <ThrowOnError extends boolean = false>(options: Options<DeleteReltypeData, ThrowOnError>) => {
    return (options.client ?? client).delete<DeleteReltypeResponses, unknown, ThrowOnError>({
        url: '/reltype/{reltype_id}',
        ...options
    });
};

/**
 * Update the name or description for the Relationship Type with the given ID
 */
export const putReltype = <ThrowOnError extends boolean = false>(options: Options<PutReltypeData, ThrowOnError>) => {
    return (options.client ?? client).put<PutReltypeResponses, unknown, ThrowOnError>({
        url: '/reltype/{reltype_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get an array of Relationship Types for your organisation
 */
export const getReltypes = <ThrowOnError extends boolean = false>(options?: Options<GetReltypesData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetReltypesResponses, unknown, ThrowOnError>({
        url: '/reltypes',
        ...options
    });
};

/**
 * List permissions associated with the provided Role
 */
export const getRole = <ThrowOnError extends boolean = false>(options?: Options<GetRoleData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetRoleResponses, unknown, ThrowOnError>({
        url: '/role',
        ...options
    });
};

/**
 * List all available roles - built-in and custom (defined by the current users organisation)
 */
export const getRoles = <ThrowOnError extends boolean = false>(options?: Options<GetRolesData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetRolesResponses, unknown, ThrowOnError>({
        url: '/roles',
        ...options
    });
};

/**
 * Text search for the various Object types given by 'options'.
 *
 * Optionally, filter results by project ID (project_id parameter)
 *
 * 20 results are returned per query. Results can be paged using the offset parameter.
 *
 * The following special characters can be used in searchTerm to refine the search:
 *
 * * Prepend a + symbol to a word to only see results with that word
 * * Prepend a - symbol to exlude any records containing that word
 * * Append * to a word to act as a wildcard
 *
 * For example "+green fingers find* -expensive" will find records that:
 *
 * 1. Must contain the work "green"
 * 2. Should contain "fingers"
 * 3. Should contain words starting with "find" e.g. "findings" or "finds" or "Findlay"
 * 4. Must not contain the work "expensive"
 *
 *
 * ### Results
 * A SearchResult record is returned for each hit. This has the following fields:
 *
 * * __klass__ - identifies the type of search result, corresponding to the options parameter
 * * __project_title__ - title of the associated Project
 * * __object_id__ - for questions, answers, choices and scoreComment records this is in the form
 * of a string containing section ID and question ID separated by a | character, e.g.
 * 239|121231, where 239 is the Section ID and 121231 is the Question ID. For note records
 * the object_id is the ID of that note.
 * * __object_ref__ - for questions, answers, choices and scoreComment this is the question number
 * e.g. '4.2.18'
 * * __snippet__ - this a block of text surrounding a containing the searchTerm
 * * __search_score__ - a score indicating the closeness of match
 */
export const getSearch = <ThrowOnError extends boolean = false>(options: Options<GetSearchData, ThrowOnError>) => {
    return (options.client ?? client).get<GetSearchResponses, unknown, ThrowOnError>({
        url: '/search',
        ...options
    });
};

/**
 * Calculated scores (immediate child subsections & questions) applying optional weighting
 * and scoring model (default "Unweighted"). Returns per Issue breakdown + totals.
 */
export const getSectionScores = <ThrowOnError extends boolean = false>(options: Options<GetSectionScoresData, ThrowOnError>) => {
    return (options.client ?? client).get<GetSectionScoresResponses, unknown, ThrowOnError>({
        url: '/section/{section_id}/scores',
        ...options
    });
};

/**
 * Bulk upsert of multiple scores across questions & issues within a Section for one score set.
 * Emits per-score audit events. Fails fast on permission or value validation errors.
 */
export const postSectionScoresetScores = <ThrowOnError extends boolean = false>(options: Options<PostSectionScoresetScoresData, ThrowOnError>) => {
    return (options.client ?? client).post<PostSectionScoresetScoresResponses, unknown, ThrowOnError>({
        url: '/section/{section_id}/scoreset/scores',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Coverage & subtotal summary for a Section: per-subsection progress (questions vs scored)
 * and per-question score snapshot. Used for completion dashboards. Permission: score set view.
 */
export const getSectionScoresummaries = <ThrowOnError extends boolean = false>(options: Options<GetSectionScoresummariesData, ThrowOnError>) => {
    return (options.client ?? client).get<GetSectionScoresummariesResponses, unknown, ThrowOnError>({
        url: '/section/{section_id}/scoresummaries',
        ...options
    });
};

/**
 * Create a new Tag for your organization
 */
export const postTag = <ThrowOnError extends boolean = false>(options?: Options<PostTagData, ThrowOnError>) => {
    return (options?.client ?? client).post<PostTagResponses, unknown, ThrowOnError>({
        url: '/tag',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Delete the tag with the given ID and remove all references to that tag
 * from related items.
 */
export const deleteTag = <ThrowOnError extends boolean = false>(options: Options<DeleteTagData, ThrowOnError>) => {
    return (options.client ?? client).delete<DeleteTagResponses, unknown, ThrowOnError>({
        url: '/tag/{tag_id}',
        ...options
    });
};

/**
 * Update the name and description of an existing tag
 */
export const putTag = <ThrowOnError extends boolean = false>(options: Options<PutTagData, ThrowOnError>) => {
    return (options.client ?? client).put<PutTagResponses, unknown, ThrowOnError>({
        url: '/tag/{tag_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Un-assign the Tag with the given ID from the question instances with ID values
 * provided in the TagAssigns document.
 *
 * An array of un-assigned question IDs is returned.
 */
export const deleteTagAssign = <ThrowOnError extends boolean = false>(options: Options<DeleteTagAssignData, ThrowOnError>) => {
    return (options.client ?? client).delete<DeleteTagAssignResponses, unknown, ThrowOnError>({
        url: '/tag/{tag_id}/assign',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Assign the Tag with the given ID to the question instances with ID values
 * provided in the TagAssigns document.
 *
 * Duplicate assignments are silently ignored.
 *
 * An array of assigned question IDs is returned.
 */
export const postTagAssign = <ThrowOnError extends boolean = false>(options: Options<PostTagAssignData, ThrowOnError>) => {
    return (options.client ?? client).post<PostTagAssignResponses, unknown, ThrowOnError>({
        url: '/tag/{tag_id}/assign',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get an array of all the Tags defined by your organization
 */
export const getTags = <ThrowOnError extends boolean = false>(options?: Options<GetTagsData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetTagsResponses, unknown, ThrowOnError>({
        url: '/tags',
        ...options
    });
};

/**
 * Get an array of objects, one for each tag, listing the question ids assigned to each
 * tag for the given section_id.
 *
 * N.B. - this operation is not recursive only questions that are direct children of the given
 * section ID are considered
 */
export const getTagsSection = <ThrowOnError extends boolean = false>(options: Options<GetTagsSectionData, ThrowOnError>) => {
    return (options.client ?? client).get<GetTagsSectionResponses, unknown, ThrowOnError>({
        url: '/tags/section/{section_id}',
        ...options
    });
};

/**
 * Delete the user account given by 'id' in the body document.
 *
 * If the user ID is that of the current user an HTTP 400 Error reponse is returned -
 * a user cannot delete themselves via this method.
 */
export const deleteUser = <ThrowOnError extends boolean = false>(options?: Options<DeleteUserData, ThrowOnError>) => {
    return (options?.client ?? client).delete<DeleteUserResponses, unknown, ThrowOnError>({
        url: '/user',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Fetch an existing User by ID
 */
export const getUser = <ThrowOnError extends boolean = false>(options: Options<GetUserData, ThrowOnError>) => {
    return (options.client ?? client).get<GetUserResponses, unknown, ThrowOnError>({
        url: '/user',
        ...options
    });
};

/**
 * Create a new user account.
 *
 * User ID must be unique across the system. An HTTP 409 response is returned
 * if the user ID provided already exists in the database;
 */
export const postUser = <ThrowOnError extends boolean = false>(options?: Options<PostUserData, ThrowOnError>) => {
    return (options?.client ?? client).post<PostUserResponses, unknown, ThrowOnError>({
        url: '/user',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Update an existing user account
 */
export const putUser = <ThrowOnError extends boolean = false>(options?: Options<PutUserData, ThrowOnError>) => {
    return (options?.client ?? client).put<PutUserResponses, unknown, ThrowOnError>({
        url: '/user',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * List users belonging to the Organisation given by orgId. If this parameter is not provided
 * then users are returned for the current logged-in user's organisation.
 */
export const getUsers = <ThrowOnError extends boolean = false>(options?: Options<GetUsersData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetUsersResponses, unknown, ThrowOnError>({
        url: '/users',
        ...options
    });
};

/**
 * Vendor organisation profile (Consultant users only): organisation details plus
 * Issues involving this buyer and the vendor's users.
 */
export const getVendor = <ThrowOnError extends boolean = false>(options?: Options<GetVendorData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetVendorResponses, unknown, ThrowOnError>({
        url: '/vendor',
        ...options
    });
};

/**
 * Delete the webhook for the given `event_type` - `org_id` combination
 */
export const deleteWebhook = <ThrowOnError extends boolean = false>(options?: Options<DeleteWebhookData, ThrowOnError>) => {
    return (options?.client ?? client).delete<DeleteWebhookResponses, unknown, ThrowOnError>({
        url: '/webhook',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Save a new Webhook subscribing to the event_type given in the body JSON document.
 *
 * The will sent a POST request to the provided `url` with a JSON encoded body for each event
 * of the given `event_type`.
 */
export const postWebhook = <ThrowOnError extends boolean = false>(options?: Options<PostWebhookData, ThrowOnError>) => {
    return (options?.client ?? client).post<PostWebhookResponses, unknown, ThrowOnError>({
        url: '/webhook',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Update the `remote_url` or `http_header` for the Webhook with the given event_type / org_id.
 *
 * delivery_status and retries are reset to default values
 */
export const putWebhook = <ThrowOnError extends boolean = false>(options?: Options<PutWebhookData, ThrowOnError>) => {
    return (options?.client ?? client).put<PutWebhookResponses, unknown, ThrowOnError>({
        url: '/webhook',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Fetch an array of event types which accept webhook subscriptions
 */
export const getWebhookEvents = <ThrowOnError extends boolean = false>(options?: Options<GetWebhookEventsData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetWebhookEventsResponses, unknown, ThrowOnError>({
        url: '/webhook/events',
        ...options
    });
};

/**
 * Fetch an array of Webhook objects for the current users' organisation, or, if given, the
 * organisation indicated by query param `orgId`.
 */
export const getWebhooks = <ThrowOnError extends boolean = false>(options?: Options<GetWebhooksData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetWebhooksResponses, unknown, ThrowOnError>({
        url: '/webhooks',
        ...options
    });
};
